module.exports = __webpack_public_path__ + "img/invoice-de-female-he.6117ad80.png";